// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__5OpY2","Hero":"Home_Hero__kGJoJ","HeroDescription":"Home_HeroDescription__4VeMK","HeroImage":"Home_HeroImage__cVSfi"};